const workCategories = {
  featured: { id: "featured", title: "Featured" },
  cool: { id: "cool", title: "Something Cool" },
}

const workAunatural = {
  project: {
    title: "Au Natural Skinfood",
    url: "https://www.aunaturalskinfood.com/",
  },
  contents: [
    {
      type: "image",
      source: "aunatural",
      text:
        "Worked as the full-stack engineer with NodeJS to build a customized eCommerce solution with Recurly, a Subscription/Recurring Platform.",
    },
    {
      type: "image",
      source: "aunatural01",
      text:
        "Designed and developed APIs with a set of business rules. Reactive programming for robust pricing and GST calculation.",
    },
    {
      type: "image",
      source: "aunatural02",
      text:
        "OAuth2 with social login, session management, etc. Used Pug, Web APIs, TailwindCSS and JavaScript to power the site.",
    },
  ],
}

const workKohuratia = {
  project: {
    title: "Kohuratia",
    url: "https://www.kohuratia.nz/welcome",
  },
  contents: [
    {
      type: "image",
      source: "kohuratia",
      text:
        "Worked as the full-stack engineer with NodeJS. Implemented new features on an existing project. Such as data vitalization and survey system.",
    },
  ],
}

const workAllRight = {
  project: {
    title: "All Right?",
    url: "https://www.allright.org.nz/",
  },
  contents: [
    {
      type: "image",
      source: "allright",
      text:
        "AllRight powered by CraftCMS and Craft Commerce as the back-end system. VueJS and Twig for UI/UX.",
    },
    {
      type: "video",
      source: "023758e335144dc483e4f292c71bc29c",
      text: "🔊 Please allow me to walk you though the site in 5 mins =)",
    },
    {
      type: "image",
      source: "allright01",
      text:
        "The campaign aimed to maintain and increase the wellbeing of people from Canterbury and nationwide.",
    },
    {
      type: "image",
      source: "allright02",
      text:
        "The GGT was the one of government’s mental health toolkit to help kiwis during the COVID-19 lockdown.",
    },
  ],
}

const workNZBEX = {
  project: {
    title: "NZ Beer Exchange",
    url: "https://www.nzbex.nz/",
  },
  contents: [
    {
      type: "image",
      source: "nzbex",
      text: "A one-stop-shop for local producers with backward auction system.",
    },
    {
      type: "image",
      source: "nzbex01",
      text:
        "The side is powered by CraftCMS. I've worked as the JS/Vue developer.",
    },
    {
      type: "image",
      source: "nzbex02",
      text:
        "Designed/Developed event-driven solution for connecting different components.",
    },
  ],
}

const workDineFind = {
  project: {
    title: "Dine Find",
    url: "https://www.dinefind.co.nz/",
  },
  contents: [
    {
      type: "image",
      source: "dinefind",
      text:
        "DineFind is part of Restaurant Association of NZ. The app has launched during the COVID-19 lockdown alert level-3.",
    },
    {
      type: "video",
      source: "8168b6f36ed7476d9394d114ff81b257",
      text:
        "🔇 Implemented the finding the nearby restaurants on the map feature which is similar to Airbnb.",
    },
    {
      type: "image",
      source: "dinefind01",
      text:
        "Designed and Developed restaurants syncing system with CraftCMS FeedMe and AWS Lambda Functions",
    },
    {
      type: "image",
      source: "dinefind02",
      text: "Developed APIs for front-end to consume",
    },
  ],
}

const workTheArts = {
  project: {
    title: "The Arts Foundation",
    url: "https://www.thearts.co.nz/",
  },
  contents: [
    {
      type: "image",
      source: "thearts",
      text:
        "Worked as a Javascript/CraftCMS developer to build UI/UX and API development. The site powered by CraftCMS.",
    },
    {
      type: "video",
      source: "ca500e6309e548179129f89ccd09a184",
      text:
        "🔇 Implement the mini version of Photoshop with Web Canvas and FabricJS",
    },
    {
      type: "image",
      source: "thearts01",
      text:
        "The most challenge part was implementing the pen tool in FabricJS, it was a absolute fun journey.",
    },
  ],
}

const workWallScape = {
  project: {
    title: "Wall Scape",
    url: "https://www.wallscape.co.nz/",
  },
  contents: [
    {
      type: "image",
      source: "wallscape",
      text:
        "The site powered by CraftCMS and Craft Commerce and JavaScript for it's online wall paper modification tool.",
    },
    {
      type: "image",
      source: "wallscape01",
      text:
        "Integrated with Shuttersotck API that allow users to find the image from millions",
    },
    {
      type: "video",
      source: "93662ca620084a119403a75b9a03cce8",
      text:
        "🔇 Enhanced the design tool that store user modification info as JSON data in order",
    },
    {
      type: "image",
      source: "wallscape02",
      text: "📷 The design tool for building the customized wall paper.",
    },
    {
      type: "image",
      source: "wallscape03",
      text:
        "Designed and developed a local app for the image licensing and redo the image modification with JSON data.",
    },
  ],
}

const workLecase = {
  project: {
    title: "Lecase Paris (offline)",
    url: "https://www.wallscape.co.nz/",
  },
  contents: [
    {
      type: "image",
      source: "lecase",
      text:
        "A Gatsby Site with React + Redux. Added eCommerce solution to Gatsby, It was an insane idea at the time.",
    },
    {
      type: "image",
      source: "lecase01",
      text:
        "Integrated with Firebase Auth and Firebase Functions, they work together magically.",
    },
  ],
}

const workStyxMill = {
  project: {
    title: "Styx Mill Garment Manager",
    url: "https://fgm.styxmill.com/",
  },
  contents: [
    {
      type: "image",
      source: "styxmill",
      text:
        "A single page application with Google Firebase Suite for something simple",
    },
    {
      type: "image",
      source: "styxmill01",
      text: "Utilize Element-UI for the app that does not require design",
    },
  ],
}

export default [
  workAunatural,
  workAllRight,
  workNZBEX,
  workDineFind,
  workTheArts,
  workWallScape,
  workLecase,
  workStyxMill,
  workKohuratia,
]

export const passwordList = ["2020interview"]
